import React from 'react';
import {Col, Row, Slider} from "antd";
import {Input} from "semantic-ui-react";
import './style.scss';

export default class SliderBar extends React.Component {
    state = {
        inputValue: 1,
    };

    onChange = value => {
        this.setState({
                          inputValue: value,
                      });
    };

    render() {
        const { inputValue } = this.state;
        return (
            <div className={'slider'}>
            <Row>
                <Col span={12}>
                    <Slider
                        min={1}
                        max={24}
                        onChange={this.onChange}
                        value={typeof inputValue === 'number' ? inputValue : 0}
                    />
                </Col>
                  <p className={"ant-slider-col"}><b>{inputValue} hrs</b></p>
            </Row>
        </div>
        );
    }

}

